export const homePage = {
  maxTilesPerCarouselPage: 6
};

export const common = {
  numberOfInGameIcons: 3,
  numberOfInGameNames: 1,
  numberOfGameTilesPerLoad: 60
};

export default {
  homePage,
  common
};
